import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'The Bluntsheep',
    description: 'The Bluntsheep is a pop rock band from Malaysia, formed in late 2023. Meet Atta, Moses, Umar and Arif, hear the songs, and book the band.',
    placeholder: 'Blunt is light. Blunt is tight. Choose your path right.',
    url: getOrigin()
}
